/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectSettingsUpdateRequest
 */
export interface ProjectSettingsUpdateRequest {
    /**
     * Threshold over which a subsequent administration validation is required
     * @type {number}
     * @memberof ProjectSettingsUpdateRequest
     */
    quoteValidationThreshold?: number;
    /**
     * An alternative email address for sending initial quote submission instead of defined client
     * @type {string}
     * @memberof ProjectSettingsUpdateRequest
     */
    quoteValidationAlternativeInitialEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectSettingsUpdateRequest
     */
    projectAutoValidationDelay: ProjectSettingsUpdateRequestProjectAutoValidationDelayEnum;
}


/**
 * @export
 */
export const ProjectSettingsUpdateRequestProjectAutoValidationDelayEnum = {
    Standard: 'STANDARD',
    Extended: 'EXTENDED'
} as const;
export type ProjectSettingsUpdateRequestProjectAutoValidationDelayEnum = typeof ProjectSettingsUpdateRequestProjectAutoValidationDelayEnum[keyof typeof ProjectSettingsUpdateRequestProjectAutoValidationDelayEnum];


/**
 * Check if a given object implements the ProjectSettingsUpdateRequest interface.
 */
export function instanceOfProjectSettingsUpdateRequest(value: object): value is ProjectSettingsUpdateRequest {
    if (!('projectAutoValidationDelay' in value) || value['projectAutoValidationDelay'] === undefined) return false;
    return true;
}

export function ProjectSettingsUpdateRequestFromJSON(json: any): ProjectSettingsUpdateRequest {
    return ProjectSettingsUpdateRequestFromJSONTyped(json, false);
}

export function ProjectSettingsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectSettingsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteValidationThreshold': json['quoteValidationThreshold'] == null ? undefined : json['quoteValidationThreshold'],
        'quoteValidationAlternativeInitialEmail': json['quoteValidationAlternativeInitialEmail'] == null ? undefined : json['quoteValidationAlternativeInitialEmail'],
        'projectAutoValidationDelay': json['projectAutoValidationDelay'],
    };
}

export function ProjectSettingsUpdateRequestToJSON(value?: ProjectSettingsUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'quoteValidationThreshold': value['quoteValidationThreshold'],
        'quoteValidationAlternativeInitialEmail': value['quoteValidationAlternativeInitialEmail'],
        'projectAutoValidationDelay': value['projectAutoValidationDelay'],
    };
}

